export const fr = {
  form: {
    email: {
      invalid: "Email invalide",
      emailTaken: "Compte déjà créé avec le même email",
      emailAvailable: "Email disponible",
    },
    fields: {
      email: "Email",
      first_name: "Prénom",
      last_name: "Nom de famille",
      password: "Mot de passe",
      position: "Poste",
    },
  },
  integer_type: {
    sub_text: "Appuyez sur Entrée pour continuer",
  },
  buttons: {
    next: "Suivant",
    sign_up: "S'inscrire",
    go_to_sign_in: "Aller à la connexion",
  },
  links: {
    terms_and_conditions: "Conditions générales",
    privacy_policy: "Politique de confidentialité",
    and: "et",
  },
  passwordComplexity: {
    number: "Au moins un chiffre",
    specialCharacter: "Au moins un caractère spécial",
    lowercase: "Au moins une lettre minuscule",
    uppercase: "Au moins une lettre majuscule",
    length: "Au moins 8 caractères",
  },
  maintencePage: {
    title: "En maintenance",
    description:
      "Nos ingénieurs effectuent actuellement une maintenance planifiée sur le tableau de bord.",
    apology: "Désolé pour le désagrément.",
  },
};
